module.exports = __webpack_public_path__ + "static/assets/1564d99f551cbda7c3ae888e00c67d9d.svg";